import React, { useEffect, useState } from 'react'
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ReactStars from "react-rating-stars-component";
import ErrorLabel from '../error_label';
import { actionAddFeedback, resetAddFeedbackResponse } from '../../common/store';
import { TOAST_DURATION, TOAST_ERROR_COLOR, TOAST_POSITION, TOAST_SUCCESS_COLOR } from '../../common/app_constant';
import { toast } from 'react-hot-toast';
import $ from 'jquery';


const CustomerFeedback = (props) => {

    const dispatch = useDispatch()
    const navigation = useNavigate()


    const { addFeedback } = useSelector((state) => ({
        ...state.commonStore
    }))

    const {
        register,
        formState: { errors },
        handleSubmit,
        control,
        reset,
        setValue,
        clearErrors
    } = useForm({
        defaultValues: {
            comment: '',
            rate_us: ''
        },
    });

    useEffect(() => {
        if (addFeedback !== null) {
            dispatch(resetAddFeedbackResponse())
            if (addFeedback.result === true) {
                $(".modal-backdrop").remove();
                toast.success(addFeedback.message, {
                    duration: TOAST_DURATION,
                    position: TOAST_POSITION,
                    style: {
                        color: TOAST_SUCCESS_COLOR
                    }
                })
                clearErrors()
                props.feedbackClose()
            } else {
                switch (addFeedback.status) {
                    case 400:
                        toast.error(addFeedback.message, {
                            duration: TOAST_DURATION,
                            position: TOAST_POSITION,
                            style: {
                                color: TOAST_ERROR_COLOR
                            }
                        })
                        localStorage.clear()
                        navigation("/login", { replace: true });
                        break;
                    default:
                }
            }
        }
    }, [addFeedback])

    const onSubmit = async (data) => {
        dispatch(actionAddFeedback({
            comment: data.comment,
            rate_us: data.rate_us
        }))
    };

    return (
        <>
            <div
                className="modal fade show"
                id="customerfeedback"
                tabIndex={-1}
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
                style={{ display: props.isCustomerFeedback === true ? 'block' : 'none' }}>

                <div className="modal-dialog">
                    <form
                        noValidate
                        autoComplete="off"
                        onSubmit={handleSubmit(
                            onSubmit
                        )}
                    >
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">
                                    Customer feedback
                                </h5>

                                <button
                                    type="button"
                                    className="btn"
                                    data-bs-dismiss="modal"
                                    onClick={() => {
                                        setValue('rate_us', '')
                                        setValue('comment', '')
                                        clearErrors()
                                        props.feedbackClose()
                                    }}
                                >
                                    <i className="fa fa-close" />

                                </button>
                            </div>
                            <div className='d-flex col-12 align-items-center justify-content-center'>
                                <Controller
                                    control={control}
                                    name="rate_us"
                                    render={({ field: { value, onChange } }) => (
                                        <ReactStars
                                            count={5}
                                            onChange={onChange}
                                            value={value}
                                            size={40}
                                            isHalf={true}
                                            activeColor="#e1056d"
                                        />
                                    )}
                                    rules={{
                                        required: "Please select ratings"
                                    }}
                                />

                            </div>
                            <div className='d-flex col-12 align-items-center justify-content-center'>
                                {errors.rate_us && (
                                    <ErrorLabel
                                        message={
                                            errors
                                                .rate_us
                                                ?.message
                                        }
                                    />
                                )}
                            </div>
                            <div className="modal-body feedback">
                                <textarea
                                    className="form-control"
                                    rows={5}
                                    name='comment'
                                    {...register(
                                        "comment",
                                        {
                                            required: "Tell us what is on your mind..."
                                        }
                                    )}
                                />
                                {errors.comment && (
                                    <ErrorLabel
                                        message={
                                            errors
                                                .comment
                                                ?.message
                                        }
                                    />
                                )}
                            </div>
                            <div className="modal-footer">
                                <button type="submit" className="btn btn-primary">
                                    Submit Feedback
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </>
    )

}

export default CustomerFeedback;